import { enableScroll, stopScroll } from '../__utils/lockScroll';

const $ = jQuery.noConflict();
const triggerContent = $('.main-header__cta-wrapper--mobile .header-cta-trigger').html();

class NextSteps {
    constructor() {
        this.nextStepsMenuTrigger = $('.header-cta-trigger');
        this.nextStepsMenu = $('.menu-next-steps-container');
        this.Header = $('header.main-header');
    }
    init() {
        const th = this;
        this.nextStepsMenuTrigger.on('click', (e) => {
            if ($(e.target).hasClass('active')) {
                this.closeNextStepsMenu(e);
            } else {
                this.openNextStepsMenu(e);
            }
        });

        this.resizeNextStepsMenu();

        $(window).on('resize touchmove', () => {
            th.resizeNextStepsMenu();
        });
    }
    openNextStepsMenu(e) {
        this.resizeNextStepsMenu();
        $(e.target).addClass('active');
        this.nextStepsMenu.addClass('open');
        this.Header.addClass('with-next-steps');
        if ($(window).scrollTop() === 0) {
            $('body').css({
                'padding-top': this.Header.outerHeight(true),
            });
        }
        const menuElements = this.nextStepsMenu.find('li');

        let delay = 0;
        menuElements.each((i, v) => {
            // $(v).css('transition-delay', `${delay}s`);
            NextSteps.timeOut = setTimeout(() => {
            $(v).delay(delay).addClass('open');
            }, delay);
            delay += 150;
        });

        $('.main-header__cta-wrapper--mobile .header-cta-trigger').html('BACK TO MENU');
        stopScroll();

        e.preventDefault();
    }
    closeNextStepsMenu(e) {
        clearTimeout(NextSteps.timeOut);
        if (e) {
            e.preventDefault();
            $(e.target).removeClass('active');
        } else {
            $('.main-header__cta-wrapper--mobile .header-cta-trigger').removeClass('active');
        }

        this.nextStepsMenu.removeClass('open').find('li').css('transition-delay', '');


        this.Header.removeClass('with-next-steps');
        if ($(window).scrollTop() === 0) {
            $('body').css({
                'padding-top': '',
            });
        }
        this.nextStepsMenu.find('li').removeClass('open');
        $('.main-header__cta-wrapper--mobile .header-cta-trigger').html(triggerContent);
        enableScroll();
    }

    resizeNextStepsMenu() {
        const headerHeight = $('header.main-header').outerHeight(true);

        this.nextStepsMenu.css({
            'top': headerHeight,
            'bottom': $('.main-header__nav-mobile--wrapper').hasClass('active') ? $('.main-header__cta-wrapper--mobile').outerHeight() - 1 : '0',
        });
    }
}

export default new NextSteps();
